import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { AppContentWrapper } from 'components/root/app-content-wrapper';
import { NewVisitorManagementLayout } from './new-visitor-management-layout';
import { uiMetadata } from 'store/ui-metadata/selectors';

/**
 * Layout component for visitor registration routes
 * Wraps all routes under /visitor-registration/:ownerType/:ownerId with AppContentWrapper
 * Conditionally renders either new UI or existing UI based on visitor_management_new_ui flag
 * Uses Outlet to render nested routes
 */
export const VisitorRegistrationLayout = (): JSX.Element => {
  const metadata = useSelector(uiMetadata);
  const useNewUI = metadata?.ui_metadata?.visitor_management_new_ui === true;

  return <AppContentWrapper>{useNewUI ? <NewVisitorManagementLayout /> : <Outlet />}</AppContentWrapper>;
};
